import React, { useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SearchInput from '@components/SearchInput';

import {
  Container,
  InputSearchContainer,
  CancelButton,
} from './MenuSearchInputComponents';

const noOp = () => {};

const StyledSearchInput = styled(SearchInput)``;

const MenuSearchInput = React.forwardRef(
  (
    {
      value,
      onClick,
      onCancel,
      onChange,
      isHeader,
      disabled,
      placeholder,
      autoFocus,
      withMargin,
      background,
    },
    ref,
  ) => {
    const timeoutRef = useRef();
    const [val, setVal] = useState(value);
    const handleOnCancel = useCallback(() => {
      setVal('');
      if (onCancel) onCancel();
    }, [onCancel]);

    const handleOnChange = useCallback(
      search => {
        setVal(search);
        if (onChange) {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => {
            onChange(search);
          }, 500);
        }
      },
      [timeoutRef, onChange],
    );

    return (
      <Container isHeader={isHeader}>
        <InputSearchContainer
          isHeader={isHeader}
          hasFocus={autoFocus}
          withMargin={withMargin}
        >
          <StyledSearchInput
            ref={ref}
            value={val}
            onClick={onClick}
            onChange={handleOnChange}
            placeholder={autoFocus ? '' : placeholder}
            disabled={disabled}
            showCleanIcon={!disabled}
            autoFocus={autoFocus}
            background={background}
          />
        </InputSearchContainer>
        {!disabled && (
          <CancelButton
            label="Cancelar"
            show={autoFocus}
            onClick={handleOnCancel}
            size="small"
            color="tertiary"
          />
        )}
      </Container>
    );
  },
);

MenuSearchInput.displayName = 'MenuSearchInput';

MenuSearchInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
  isHeader: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  withMargin: PropTypes.bool,
  background: PropTypes.string,
};

MenuSearchInput.defaultProps = {
  value: '',
  onClick: noOp,
  onCancel: noOp,
  onChange: noOp,
  isHeader: false,
  disabled: false,
  autoFocus: false,
  withMargin: true,
};

export default MenuSearchInput;
